export class NotifyService {
    constructor(private toaster: toaster.IToasterService) {
        'ngInject';
    }

    public success = (title: string = 'Succes', message: string = 'Done!') => {
        this.toaster.pop('success', title, message);
    }

    public error = (title: string = 'Error', message: string = 'Something went wrong!') => {
        this.toaster.pop('error', title, message);
    }

}


// WEBPACK FOOTER //
// ./~/@abosol/theme/src/app/services/notify.service.ts